module.exports = __webpack_public_path__ + "static/media/classicos_feminino_sapatos.c2a16b55.jpg";